import React, { useEffect } from 'react';
import { Page } from '@components/page';
import { LeftOutlined } from '@ant-design/icons';
import { useDispatch } from 'react-redux';
import { Header } from './components/header';
import { Body } from './components/body';
import { CardTable } from '@components/table/styled';
import { Col } from 'antd';
import { fetchAllCustomers } from '@redux/slices/order';
import { fetchDivisions } from '@redux/slices/divisions';
import {
    fetchMinimumOrder,
    fetchTransportTypes,
} from '@redux/slices/min-order';
import { translate } from '@components/i18n';

export const MinOrder: React.FC = () => {
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(fetchMinimumOrder());
        dispatch(fetchDivisions());
        dispatch(fetchTransportTypes());
        dispatch(fetchAllCustomers());
    }, []);

    return (
        <Page
            title={translate('pages.minOrder')}
            greyBackground
            onClickGoBack
            menuIcon={<LeftOutlined />}
        >
            <Col span={22} style={{ alignSelf: 'center' }}>
                <h2 style={{ marginTop: '15px' }}>
                    {translate('titlePages.minOrder')}
                </h2>
                <CardTable>
                    <Header />
                    <Body />
                </CardTable>
            </Col>
        </Page>
    );
};
